<template>
  <div class="pa-3 grey lighten-4">
    <!-- Thumbnail Section -->
    <v-card fill-height>
      <media-container
        ref="thumbnailContainer"
        :media_type="DEFINES.MEDIA.FILM.THUMBS"
        :mime_type="DEFINES.MIME_TYPE.IMAGE"
        :max_selections="1"
        :collection="DEFINES.COLLECTION_PUBLIC"
        @link="onLink"
        @removeMedia="removeMedia"
      ></media-container>
    </v-card>

    <!-- Thumbnail Section -->
    <v-card fill-height class="mt-3">
      <media-container
        ref="posterContainer"
        :media_type="DEFINES.MEDIA.FILM.POSTERS"
        :mime_type="DEFINES.MIME_TYPE.IMAGE"
        :max_selections="1"
        :collection="DEFINES.COLLECTION_PUBLIC"
        @link="onLink"
        @removeMedia="removeMedia"
      ></media-container>
    </v-card>

    <!-- Screener Source -->
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4">
        <h3 class="secondary--text">
          {{ $t(`film.update.tabs.files.section.screener_source`) }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn small color="primary" dark @click.stop="watchPreview">{{
            $t("screener.btn.preview")
          }}</v-btn>
        <v-btn color="success" @click="$emit('onSave', film)" small>Save</v-btn>
      </v-card-title>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 class="px-3 py-4">
            <h3
              class="grey--text text--darken-3 pb-3"
              v-html="$t('screener.save.streaming_src.headline')"
            ></h3>

            <v-radio-group
              hide-details
              v-model="film.is_external_src"
              row
              class="mt-2"
            >
              <RadioInput
                :value="0"
                :label="$t('screener.streaming.internal')"
              ></RadioInput>
              <RadioInput
                :value="1"
                :label="$t('screener.streaming.external')"
              ></RadioInput>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card>
      <div v-if="film.id">
        <!-- In case of Intrernal way -->
        <Streaming
          v-if="!film.is_external_src"
          v-model="film.external_url"
          :isExternalSrc="false"
          :film_id="film.id"
        />
        <!-- In case of External way -->
        <div v-if="film.is_external_src" class="px-3">
          <Streaming
            v-model="film.external_url"
            :isExternalSrc="true"
            :isExternalSrcRequired="film.is_external_src"
            :film_id="film.id"
          />
          <!-- <v-checkbox
            class="ma-0"
            color="primary"
            v-if="film.id"
            label="Streaming from external source"
            v-model="film.is_external_src"
          ></v-checkbox> -->
        </div>
      </div>
      <div v-else>
        <v-card-title class="justify-center my-5">
          <div class="grey--text text--darken-3">
            {{ $t("screener.save.form.no_data") }}
          </div>
        </v-card-title>
      </div>
    </v-card>

    <!-- Upload Section -->
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4">
        <h3 class="secondary--text">
          {{ $t(`screener.media.upload.title`) }}
        </h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <media-container
        ref="screenerContainer"
        :media_type="DEFINES.MEDIA.FILM.SCREENERS"
        :mime_type="DEFINES.MIME_TYPE.VIDEO"
        :max_selections="1"
        :collection="DEFINES.COLLECTION_PRIVATE"
        @link="onLink"
        @removeMedia="removeMedia"
        :hide_title="true"
        :is_screener_upload="true"
        @watchPreview="watchPreview"
      ></media-container>
    </v-card>

    <template>
      <!-- Preview Player -->
      <v-container class="pa-0" v-if="showPreview">
        <v-dialog max-width="55vmin" v-model="showPreview" persistent>
          <v-card>
            <v-card-title>
              <div class="title">{{ $t("screener.preview.title") }}</div>
              <v-spacer></v-spacer>
              <v-btn
                small
                dark
                icon
                color="grey"
                @click="closePreview"
                class="mx-0"
              >
                <v-icon small>$vuetify.icons.rms_close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <ScreenerPlayer
                :movie="previewUrl"
                :subtitles="subtitles"
              ></ScreenerPlayer>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </template>
    <!-- Subtitles -->
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4">
        <h3 class="secondary--text">
          {{ $t("screener.avails.subtitles.heading") }}
        </h3>
      </v-card-title>
      <Subtitles :film="film" />
    </v-card>
    <AssetsLinker
      :show="assets_linker.show"
      :model="film"
      :model_type="DEFINES.MODEL_FILM"
      :current_media_type="assets_linker.current_media_type"
      :selected_medias="assets_linker.selected_medias"
      :mime_type="assets_linker.mime_type"
      :max_selections="assets_linker.max_selections"
      :collection="assets_linker.collection"
      @close="assets_linker.show = false"
      @updateMediaType="updateMediaType"
    ></AssetsLinker>
  </div>
</template>
<script>
import MediaContainer from "@/components/media/MediaContainer";
import AssetsLinker from "@/components/assets/AssetsLinker";
import Streaming from "@/components/media/Streaming";
import ScreenerPlayer from "@/components/screener/Player";
import Subtitles from "@/components/media/Subtitles";
import RadioInput from "@/components/RadioInput";
export default {
  name: "FilmFiles",
  props: {
    film: {
      type: Object,
      default: null,
    },
  },
  components: {
    MediaContainer,
    AssetsLinker,
    Streaming,
    ScreenerPlayer,
    Subtitles,
    RadioInput,
  },
  data() {
    return {
      currentStep: 1,
      showPreview: false,
      previewUrl: null,
      assets_linker: {
        show: false,
        current_media_type: null,
        max_selections: null,
        selected_medias: null,
        mime_type: null,
        collection: null,
      },
    };
  },
  watch:{
    'film.is_external_src'(newVal){
      if(newVal==0 && this.film.screeners.length==0){
        this.$refs.screenerContainer.linkMore()
      }
    },
  },
  computed: {
    movie: function () {
      return this.$store.getters["film/getMediasFromId"](
        this.DEFINES.MEDIA.FILM.SCREENERS
      )[0];
    },
    enablePreview: function () {
      if (this.film.is_external_src) return this.film.external_url !== null;
      else
        return this.movie
          ? this.movie.encoding_status == this.DEFINES.ENCODING_STATUS.ENCODED
          : false;
    },
    subtitles: function () {
      return this.$store.getters["files/getSubtitles"]();
    },
  },
  methods: {
    onLink(event) {
      this.assets_linker.show = true;
      this.assets_linker.current_media_type = event.media_type;
      this.assets_linker.max_selections = event.max_selections;
      this.assets_linker.collection = event.collection;
      this.assets_linker.selected_medias = Object.assign(
        [],
        this.film[event.media_type]
      );
      this.assets_linker.mime_type = event.mime_type;
    },
    async updateMediaType(event) {
      this.film[this.assets_linker.current_media_type] = event.selected;
      this.$emit("onSave", this.film);

      //TODO:: NEED TO BE FIXED (UPDATING GLOBAL STATE)
      await this.$store.dispatch("files/get", {
          model_type: "film",
          model_id: this.film.id
      });
      await this.$store.dispatch("film/setEditableFilm", {
        id: this.$route.params.film_id
      });
    },

    async removeMedia(event) {
      let filterd_data = this.film[event.media_type].filter(
        (id) => id !== event.media_id
      );
      this.film[event.media_type] = filterd_data;
    },

    watchPreview() {
      this.currentStep = 3;
      if (!this.enablePreview) {
        return;
      }
      this.previewUrl = this.film.is_external_src
        ? this.film.external_url
        : this.movie.screener_edge_url;
      this.showPreview = true;
    },

    closePreview() {
      this.showPreview = false;
      this.previewUrl = null;
    },
    /**
     * ================================================================================
     *                                Refs Manipulators
     * ================================================================================
     */

    // Open Media uploader
    openUploadBox() {
      this.$refs.screenerContainer.linkMore()
    }
  },
};
</script>
